import getLang from 'I18n/utils/getLang';
import { GET_SUGGESTION_SECTIONS_QUERY as PUBLIC_GET_SUGGESTION_SECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { GET_SUGGESTION_SECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { DEFAULT_MAX_SECTION_CARD_COUNT, DEFAULT_MAX_SECTIONS, DEFAULT_MIN_SECTION_CARD_COUNT } from '../constants/suggestions';
import { usePersonalizationQuery } from './usePersonalizationQuery';
export function useGetSuggestionSections(options) {
  var _options$maximumSecti, _options$minimumSecti, _options$maximumSecti2;
  return usePersonalizationQuery({
    public: PUBLIC_GET_SUGGESTION_SECTIONS_QUERY,
    app: GET_SUGGESTION_SECTIONS_QUERY,
    options: {
      variables: {
        maximumSections: (_options$maximumSecti = options === null || options === void 0 ? void 0 : options.maximumSections) !== null && _options$maximumSecti !== void 0 ? _options$maximumSecti : DEFAULT_MAX_SECTIONS,
        language: getLang(),
        minimumSectionCardCount: (_options$minimumSecti = options === null || options === void 0 ? void 0 : options.minimumSectionCardCount) !== null && _options$minimumSecti !== void 0 ? _options$minimumSecti : DEFAULT_MIN_SECTION_CARD_COUNT,
        maximumSectionCardCount: (_options$maximumSecti2 = options === null || options === void 0 ? void 0 : options.maximumSectionCardCount) !== null && _options$maximumSecti2 !== void 0 ? _options$maximumSecti2 : DEFAULT_MAX_SECTION_CARD_COUNT,
        productTypes: (options === null || options === void 0 ? void 0 : options.productTypes) || ['APP', 'AGENT']
      }
    }
  });
}